import {DestroyRef, inject, provideAppInitializer} from '@angular/core';
import {Actions, ofActionDispatched, Store} from '@ngxs/store';
import {ClearSearchQueryAction, SetSearchLoadingAction, SetSearchStateAction, UpdateSearchQueryAction} from './actions';
import {distinctUntilChanged, filter, map, merge, switchMap} from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {SearchService} from '../../../search/search.service';
import {SearchInputViewService} from '../../services/search.service';
import {Navigate} from '@ngxs/router-plugin';
import {initialState} from './model';

export const searchQueryActionListener = provideAppInitializer(() => {
  const destroyRef = inject(DestroyRef);
  const actions = inject(Actions);
  const store = inject(Store);
  const searchService = inject(SearchService);
  const searchInputService = inject(SearchInputViewService);

  const listener = actions.pipe(
    ofActionDispatched(UpdateSearchQueryAction),
    map(({query}) => query.trim()),
    distinctUntilChanged(),
    switchMap((query) => searchService.search(query).pipe(
      switchMap(response => store.dispatch(new SetSearchLoadingAction(false)).pipe(
        switchMap(() => store.dispatch(new SetSearchStateAction({
          ...response,
          query,
          loading: false,
        })))
      )),
    )),
    takeUntilDestroyed(destroyRef)
  );

  const inputMonitor = searchInputService.searchTermChanged$.pipe(
    filter(query => query.length > 3),
    switchMap(query => store.dispatch([
      new SetSearchStateAction({
        ...initialState,
        loading: true,
      }),
      new Navigate(['/search'], { q: query }),
      new UpdateSearchQueryAction(query),
    ])),
    takeUntilDestroyed(destroyRef)
  );

  const clearQuery = searchInputService.searchTermChanged$.pipe(
    filter(query => query.length === 0),
    switchMap(() => store.dispatch(new ClearSearchQueryAction())),
    takeUntilDestroyed(destroyRef)
  );

  merge(listener, inputMonitor, clearQuery).subscribe();
});
